<template>
    <div class="pubDialogMasker" v-if="dialogVisible">
        <el-card class="pubDialog">
            <p class="title">关注公众号</p>
            <img class="wxicon" referrerpolicy="no-referrer" :src="wechat" alt="" />
            <p class="subtitle">关注雅思哥课堂公众号，享上课提醒贴心服务</p>
            <div class="codeWrapper">
                <img class="qrcode" v-if="wxPubAccountQrcode" referrerpolicy="no-referrer" :src="wxPubAccountQrcode" />
            </div>
            <div class="btn" @click="handleCheck">关注好啦</div>
        </el-card>

    </div>
</template>
<script>
import { createQrCode, checkFollowedStatus } from "@/services/user"
import { createNamespacedHelpers } from "vuex";

const authHelper = createNamespacedHelpers("auth");


export default {
    data() {
        return {
            wechat: "https://static.ieltsbro.com/base_service/base/image/1670911325312.png",
            dialogVisible: false,
            wxPubAccountQrcode: ""
        }
    },
    computed: {
        ...authHelper.mapGetters(["phone"]),
    },
    watch: {
        dialogVisible: function (val) {
            if (val && !this.wxPubAccountQrcode) {
                this.createQRCodeImage()
            }
        }
    },
    methods: {
        handleOpen() {
            this.dialogVisible = true
        },
        handleClose() {
            this.dialogVisible = false
        },
        async handleCheck() {
            const hasFollowed = await checkFollowedStatus()
            if (!hasFollowed) {
                this.$message.error("您还没有关注公众号哦～")
                return false
            }
            this.handleClose()
        },
        async createQRCodeImage() {
            const res = await createQrCode({ phone: this.phone, zone: "86" })
            this.wxPubAccountQrcode = res
        }
    }
}

</script>
<style lang="scss" scoped>
.pubDialogMasker {
    min-height: calc(100vh - 150px);
    width: calc(100vw - 282px);
    background: rgba(255, 255, 255, 0.8);
    position: absolute;
    z-index: 99;
}

.pubDialog {
    width: 562px;
    height: 613px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #FFFFFF;
    border-radius: 24px;

    .title {
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #131B33;
        line-height: 26px;
        text-align: center;
        margin-bottom: 50px;
    }

    .wxicon {
        display: block;
        margin: auto;
        width: 44px;
        height: 44px;
    }

    .subtitle {
        font-size: 22px;
        font-family: MicrosoftYaHei;
        color: #333643;
        line-height: 29px;
        margin-top: 10px;
        text-align: center;
    }

    .codeWrapper {
        width: 240px;
        height: 240px;
        display: block;
        margin: 60px auto 47px;
        background: #F5F6FA;
        border-radius: 50%;
    }

    .qrcode {
        width: 240px;
        height: 240px;
        display: block;
    }

    .btn {
        width: 118px;
        background: #3377FF;
        border-radius: 13px;
        line-height: 42px;
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
        margin: auto;
        cursor: pointer;
    }

}
</style>


// WEBPACK FOOTER //
// src/components/FollowedPubAccount/index.vue